/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const HelpCircleStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9 9.36302C9.31842 7.93439 10.5684 6.94384 11.976 7.00465C13.5514 6.91382 14.902 8.1635 15 9.80279C15 11.9069 12.1104 12.6009 12.1104 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12.1" cy="16.5" fill="none" r="0.75" />
      </svg>
    </Icon>
  );
});

export { HelpCircleStrokeIcon };
